/**
 * The attribute `global-error.tsx` stamps on the `<body>` it renders, so
 * anything watching the document can tell "the root boundary took the page"
 * from "React threw the page away".
 *
 * 🚨 IMPORT-FREE, like everything the global boundary imports: it is the
 * screen that has to render when nothing else can.
 *
 * The hydration detector reads it (MUCKA-WEB-A2, 21 Oct 2026). The boundary
 * replaces every child of body, which is the detector's trigger, so without
 * the mark a ChunkLoadError the boundary had already logged and reloaded for
 * was filed a second time as a server/client mismatch that never happened.
 * React applies a body's attributes in the same commit that removes the old
 * children, so the mark is there by the time a MutationObserver hears of it.
 */
export const GLOBAL_BOUNDARY_ATTR = 'data-mucka-boundary';
export const GLOBAL_BOUNDARY_VALUE = 'global';

/** Is the document's body the global boundary's, rather than the app's? */
export function globalBoundaryHasDocument(): boolean {
  try {
    return document.body?.getAttribute(GLOBAL_BOUNDARY_ATTR) === GLOBAL_BOUNDARY_VALUE;
  } catch {
    return false;
  }
}
